import {normalizarBusqueda,matchNames} from './prescriptorSearch';
export const indiceDiagnosticos=values=>values.map(text=>({text,normalized:normalizarBusqueda(text),words:normalizarBusqueda(text).split(' ')}));
export function buscarDiagnosticos(index,input,limit=30){
 const query=normalizarBusqueda(String(input??'').slice(0,160));
 if(!query)return index.slice(0,limit).map(row=>({text:row.text,similar:false}));
 return index.map(row=>{
  if(row.normalized===query)return {text:row.text,similar:false,score:-100};
  if(row.normalized.includes(query))return {text:row.text,similar:false,score:0};
  const match=matchNames(query.split(' '),row.words);
  return match?{text:row.text,similar:match.errores>0,score:match.orden+1}:null;
 }).filter(Boolean).sort((a,b)=>a.score-b.score||a.text.localeCompare(b.text)).slice(0,limit);
}
